var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(241, 242, 243, 0)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "335px",
    height: "335px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.6540222367560496s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(32.72727272727273 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.5886200130804446s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(65.45454545454545 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.5232177894048398s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(98.18181818181819 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.45781556572923476s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(130.9090909090909 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.3924133420536298s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(163.63636363636363 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.3270111183780248s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(196.36363636363637 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.2616088947024199s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(229.0909090909091 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.1962066710268149s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(261.8181818181818 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.13080444735120994s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(294.54545454545456 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "-0.06540222367560497s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(327.27272727272725 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 20.5,
    rx: 4.5,
    ry: 7.3100000000000005,
    width: 9,
    height: 17,
    fill: "#4fb4ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.7194244604316546s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.6519d90b.svg";
export { ForwardRef as ReactComponent };